import { Close } from "@mui/icons-material";
import {
  Box,
  DialogActions,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../redux/features/appSlice";
import Axios from "../../../../../../axios/Axios";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import SessionPerformance from "../../../../Settings/student_training/modals/SessionPerformance";
import { ShowFullText } from "../../../../../Reusable/ShowMoreText";
import dayjs from "dayjs";

export const SessionDetails = (props) => {
  // console.log(props);
  // console.log(props.setOpenSectionDetailsModal);

  // console.log(props.requestData.studentId);
  const dispatch = useDispatch();

  //Post Request: To fetch all Session details
  const viewSessionDetails = async (params) => {
    try {
      let obj = {
        // teacher_id: props.tabledata[1],
        // stud_id: props.tabledata[3]
        teacher_id: props.requestDataForSectionDetailsModal.teacherId,
        stud_id: props.requestDataForSectionDetailsModal.studentId,
        level_id: props.requestDataForSectionDetailsModal.levelId,
      };
      const response = await Axios(
        "post",
        "student/session/spoc/get/sessiondetails",
        true,
        obj
      );
      // console.log(response);
      if (response.status === 200) {
        const sortedData = response.data.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );

        params.api.applyTransaction({ add: sortedData });
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Couldn't able to retrieve session details",
          severity: "error",
        })
      );
    }
  };

  // const [defaultSort, setDefaultSort] = useMemo(()=>{
  //     return { sortable:true};
  // },[]);
  const columnDefs = [
    {
      headerName: "Name",
      field: "session_name",
      filter: false,
      sortable: true,
    },
    {
      headerName: "Date",
      field: "feedback_updated_at",
      filter: false,
      sortable: true,
      cellRenderer: (params) => {
        // Parse the ISO string and format it to DD-MM-YYYY
        const formattedDate = dayjs(params.value).format("DD-MM-YYYY");
        return params.value ? formattedDate : "";
      },
    },
    {
      headerName: "Day",
      field: "day",
      filter: false,
      hide: true,
      sortable: true,
    },
    {
      headerName: "Count",
      field: "session_count",
      filter: false,
      sortable: true,
    },
    // {
    //     headerName: "End time",
    //     field: "end_time",
    //     filter: true,
    //     sortable: true,
    // },
    {
      headerName: "Status",
      field: "session_status",
      filter: false,
      sortable: true,
    },
    {
      headerName: "Feedback",
      field: "session_feedback",
      filter: false,
      sortable: true,
    },
    {
      headerName: "Notes",
      field: "feedback_notes",
      filter: false,
      sortable: true,
      maxWidth: 200,
      cellRenderer: (params) => {
        return params.value !== null ? (
          <ShowFullText title={params.value}>
            <Typography variant="p" sx={{ cursor: "pointer" }}>
              {params.value.length > 20
                ? params.value.slice(0, 15) + "..."
                : params.value}
            </Typography>
          </ShowFullText>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Teacher Name",
      field: "teacher_name",
      filter: false,
      sortable: true,
            cellRenderer: (params) => {
        return params.value !== null ? (
          <ShowFullText title={params.value}>
            <Typography variant="p" sx={{ cursor: "pointer" }}>
              {params.value.length > 20
                ? params.value.slice(0, 15) + "..."
                : params.value}
            </Typography>
          </ShowFullText>
        ) : (
          "-"
        );
      },

    },
  ];

  return (
    <>
      <Modal
        open={props.openSectionDetailsModal}
        onClose={() => props.setOpenSectionDetailsModal(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            height: "auto",
            overflowY: "auto",
            width: "85vw",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            p: 4,
            paddingTop: "16px",
          }}
        >
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "0px",
              // marginBottom: "1rem",
            }}
          >
            <Box>
              <IconButton
                onClick={() => props.setOpenSectionDetailsModal(false)}
              >
                <Close />
              </IconButton>
              {/* <Button
                                type="button"
                                variant="contained"
                                color="inherit"
                                onClick={() => props.setOpenSectionDetailsModal(false)}
                            >
                                close
                            </Button> */}
            </Box>
          </DialogActions>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <Typography variant="h5" component="h1">
              Session Details
            </Typography>
            <Typography variant="h5" component="h1">
              Overall Session Performance
            </Typography>
            {/* <IconButton onClick={()=>props.setOpenSectionDetailsModal(false)}>
                      <Close color='primary' />
                  </IconButton> */}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box sx={{ width: "100%", height: "310px" }}>
              <AgGridReact
                className="ag-theme-alpine my-2"
                columnDefs={columnDefs}
                defaultColDef={{ flex: 1 }}
                onGridReady={viewSessionDetails}
                pagination={true}
                paginationPageSize={5}
                paginationAutoPageSize={true}
                //   sortModel ={[
                //     {colId: 'date', sort: 'asc'},
                //   ]}
              ></AgGridReact>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <div style={{ height: "270px", width: "270px" }}>
                <SessionPerformance
                  {...props.requestDataForSectionDetailsModal}
                ></SessionPerformance>
              </div>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
